

let source = null
let retryCount = 0
const MAX_RETRY = 5

// 建立SSE连接
export function connectSSE(clientId) {
  if (source) return

  // 后端SSE地址
  source = new EventSource(`/api/pda/sse/connect/${clientId}`)

  // 收到消息
  source.onmessage = (event) => {
    const msg = event.data
    console.log('收到推送：', msg)

    // 轻提示（可选）
    // ElMessage.warning(msg)
  }

  // 连接打开
  source.onopen = () => {
    console.log('SSE连接成功')
    retryCount = 0
  }

  // 连接错误 → 自动重连
  source.onerror = (err) => {
    console.error('SSE连接异常，正在重连...', err)
    closeSSE()

    if (retryCount < MAX_RETRY) {
      retryCount++
      setTimeout(() => connectSSE(clientId), 3000)
    } else {
      console.log('连接失败，请刷新页面')
    }
  }
}

// 关闭连接
export function closeSSE() {
  if (source) {
    source.close()
    source = null
  }
}



// WEBPACK FOOTER //
// ./src/util/sse.js